export function getPrivacyPolicyUrl(language: string | undefined) {
  if (language?.toLowerCase().includes("fr")) {
    return "https://vault.pactsafe.io/s/5d800911-f26c-4e3a-884d-85117a81799b/legal.html?g=37964#contract-bylz4uhm3";
  }
  return "https://certn.co/privacy-policy/";
}

export function getTermsOfUseUrl(language: string | undefined) {
  if (language?.toLowerCase()?.includes("fr")) {
    return "https://vault.pactsafe.io/s/5d800911-f26c-4e3a-884d-85117a81799b/legal.html?g=37964#contract-by4mivhzn";
  }
  return "https://vault.pactsafe.io/s/5d800911-f26c-4e3a-884d-85117a81799b/legal.html?g=37964#contract-skxc4ktljx";
}
